import { CdDocStates } from "../CdDocStates";
import { CardSection, Card } from "tessa/cards";
import { number, string } from "prop-types";
import { CdFdTaskTypes } from "../CdFdTaskTypes"
import { ChTaskTypes } from "src/pkScripts/Helpers/ChTaskTypes";


export class CdExecutiveSchemeSharedHelper {    
    public static GetRoles() {
        let roles = [{Name: string, IntID: number}];
        //@ts-ignore
        roles[0] = {IntID: 0, Name: 'Представитель лица, выполнившего работы, осуществивший подготовку исполнительной схемы'}; 
        //@ts-ignore
        roles[1] = {IntID: 1, Name: 'Представитель лица, выполнившего работы, подлежащие освидетельствованию'};
        //@ts-ignore
        roles[2] = {IntID: 2, Name: 'Представитель заказчика, ответственный за геодезическую проверку выполненных работ'}; 
        //@ts-ignore
        roles[3] = {IntID: 3, Name: 'Дополнительные согласующие'}; 
        //@ts-ignore
        roles[4] = {IntID: 4, Name: 'Авторский надзор'}; 
           
        return roles;
      }

  // Получить ID роли по состоянию (используется для синхронизации согласующий в таблице и задании)
  public static GetRoleID(docState: number | undefined | null) {
    if (!docState) {
        return -1;
    }

    if (docState === CdDocStates.OnApprovalSubcontractor.id ||
        docState === CdDocStates.OnSigningSubcontractor.id) {
        return 0;
    }
    else if (docState === CdDocStates.OnApprovalContractor.id ||
             docState === CdDocStates.OnSigningContractor.id) {
        return 1;
    }
    else if (docState === CdDocStates.OnApprovalGPExecutorWorks.id ||
             docState === CdDocStates.OnSigningGPExecutorWorks.id) {
        return 2;
    }
    else if (docState === CdDocStates.OnApprovalGP.id ||
             docState === CdDocStates.OnSigningGP.id) {
        return 3;
    }
    else if (docState === CdDocStates.OnApprovalAuthorSupervision.id ||
             docState === CdDocStates.OnSigningAuthorSupervision.id) {
        return 5;
    }
    else if (docState === CdDocStates.OnApprovalCustomer.id ||
             docState === CdDocStates.OnSigningCustomer.id) {
        return 4;
    }
    else if (docState === CdDocStates.OnApprovalOperatingOrganization.id ||
             docState === CdDocStates.OnSigningOperatingOrganization.id) {
        return 6;
    }
    else {
        return -1;
    }
  }

  // Получить актуальный номер роли согласующего
  public static GetActualRole(currentRole: number) {
    return currentRole === 4 || currentRole === 5
        ? currentRole === 4
            ? 5
            : 4
        : currentRole;
  }

  /** Получить ИД шаблона файла */
  public static GetCurrentTemplateFileRowID(card: Card) {
    let ediSection: CardSection | undefined = card.sections.tryGet('PkExecutiveDocumentationInfo');
    if (!ediSection) return null;
    let templateFileRowID: guid | undefined = ediSection.fields.tryGet('TemplateFileRowID');
    if (!templateFileRowID) return null;
    return templateFileRowID;
  }

  static ApproverTaskStoreInfo =
    {
        TaskSignTypesList : [
            CdFdTaskTypes.PkSignExecutiveSchemeAgreementTypeID,
            CdFdTaskTypes.PkSignExecutiveSchemeAgreementWithAgreementorTypeID,
            ChTaskTypes.PkSignerAgreementTypeID
        ]  
    }

}